import React from 'react';
import WorkflowManager from '../n8n-workflow/App';
import '../n8n-workflow/App.css';

const WorkflowManagement = () => {
  return <WorkflowManager />;
};

export default WorkflowManagement;
